import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/**
 * A "←" control that goes back in history when there is a page of this app to go back to, so the browser's
 * Back button doesn't bounce between two pages. Opened directly (no history), it goes to `fallback` instead.
 * It stays a real link, so it also works with middle-click and when scripts are off.
 */
export function BackLink({ fallback, className = 'btn btn-ghost', children, ...label }: { fallback: LinkProps; className?: string; children: ReactNode; 'aria-label'?: string }) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  return (
    <Link
      {...fallback}
      {...label}
      className={className}
      onClick={(e) => {
        if (!canGoBack || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        router.history.back();
      }}
    >
      {children}
    </Link>
  );
}
